// BUG-2441: a till whose template has showTillOpening = "Y" must be opened through the
// Open Till screen, which calls upsertTill and gets back the server's day-open id
// (storeDailyOpsTillid). Every order reads that id from its till event
// (useOrderProcessing.js), so a session opened only on the device bills with a NULL
// cwr_store_dailyops_till_id — and a second device opening the same till properly
// then bills with its own counter, which is how DIB/32483 was issued twice.
// Templates with showTillOpening = "N" open on the device by design and are untouched.

export const requiresServerTillOpen = (posConfig) => posConfig?.showTillOpening === "Y";

export const isPosConfigLoaded = (posConfig) => !!posConfig && typeof posConfig === "object" && Object.keys(posConfig).length > 0;

export const hasServerDayOpen = (tillEvent) => !!tillEvent?.storeDailyOpsTillid;

// Same route choice Login.js already makes for a cashier with no open till.
export const getOpenTillRoute = (posConfig) => (posConfig?.showDenominations === "Y" ? "/open-till" : "/open-till-component");

// Waiters (username listed in the store's sales reps) don't own a till — same match
// Login.js, TillModalHandler.js and PrivateRoute already use (TSK-4249).
export const isWaiterUser = (tillData, username) => {
  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
  return !!salesReps.find((rep) => rep?.name === (username || ""));
};

// An open till event may be reused only if the server knows about it, on tills that
// require a server open. Always true for showTillOpening = "N" templates and waiters.
export const canReuseOpenTillEvent = (tillEvent, posConfig, isWaiter) => !requiresServerTillOpen(posConfig) || !!isWaiter || hasServerDayOpen(tillEvent);
